import React, { useRef, useEffect } from 'react';
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  Typography,
  Button,
  Chip,
} from '@mui/material';
import {
  Person as PersonIcon,
  Badge as BadgeIcon,
  Fingerprint as FingerprintIcon,
  Receipt as ReceiptIcon,
  Phone as PhoneIcon,
  Email as EmailIcon,
  Visibility as VisibilityIcon,
  AccountCircle as AccountCircleIcon,
  ContactMail as ContactMailIcon,
} from '@mui/icons-material';
import { useHistory } from 'react-router-dom';

export default function TContactos(props) {
  const mounted = useRef(true);
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const rows = props.rows || [];
  const termc = props.termc;
  const history = useHistory();

  const abrirPerfilContacto = (contacto) => {
    history.push({ pathname: '/contactosPerfil', state: contacto });
  };

  useEffect(() => {
    return function cleanup() {
      mounted.current = false;
    };
  }, [rows]);

  const searchingTermc = (termc) => {
    return (x) => {
      const nombre = x.nombre || '';
      const apellido = x.apellido || '';
      const clienten = x.clientes?.nombre || '';
      const clientea = x.clientes?.apellido || '';
      const ci = x.ci || '';
      const ruc = x.ruc || '';

      return (
        nombre.toUpperCase().includes(termc.toUpperCase()) ||
        apellido.toUpperCase().includes(termc.toUpperCase()) ||
        clientea.toUpperCase().includes(termc.toUpperCase()) ||
        clienten.toUpperCase().includes(termc.toUpperCase()) ||
        ci.toUpperCase().includes(termc.toUpperCase()) ||
        ruc.toUpperCase().includes(termc.toUpperCase()) ||
        !termc
      );
    };
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  const filteredRows = rows.filter(searchingTermc(termc));
  const paginatedRows = filteredRows.slice(
    page * rowsPerPage,
    page * rowsPerPage + rowsPerPage
  );

  return (
    <Box sx={{ width: '100%' }}>
      <TableContainer sx={{ maxHeight: 600 }}>
        <Table stickyHeader>
          <TableHead>
            <TableRow>
              <TableCell
                sx={{
                  backgroundColor: '#e3f2fd',
                  fontWeight: 700,
                  borderBottom: 2,
                  borderColor: 'primary.main',
                  textTransform: 'uppercase',
                  letterSpacing: 0.5,
                  py: 2,
                }}
              >
                Nombre
              </TableCell>
              <TableCell
                sx={{
                  backgroundColor: '#e3f2fd',
                  fontWeight: 700,
                  borderBottom: 2,
                  borderColor: 'primary.main',
                  textTransform: 'uppercase',
                  letterSpacing: 0.5,
                  py: 2,
                }}
              >
                Apellido/Razón Social
              </TableCell>
              <TableCell
                sx={{
                  backgroundColor: '#e3f2fd',
                  fontWeight: 700,
                  borderBottom: 2,
                  borderColor: 'primary.main',
                  textTransform: 'uppercase',
                  letterSpacing: 0.5,
                  py: 2,
                }}
              >
                CI
              </TableCell>
              <TableCell
                sx={{
                  backgroundColor: '#e3f2fd',
                  fontWeight: 700,
                  borderBottom: 2,
                  borderColor: 'primary.main',
                  textTransform: 'uppercase',
                  letterSpacing: 0.5,
                  py: 2,
                }}
              >
                RUC
              </TableCell>
              <TableCell
                sx={{
                  backgroundColor: '#e3f2fd',
                  fontWeight: 700,
                  borderBottom: 2,
                  borderColor: 'primary.main',
                  textTransform: 'uppercase',
                  letterSpacing: 0.5,
                  py: 2,
                }}
              >
                Teléfono
              </TableCell>
              <TableCell
                sx={{
                  backgroundColor: '#e3f2fd',
                  fontWeight: 700,
                  borderBottom: 2,
                  borderColor: 'primary.main',
                  textTransform: 'uppercase',
                  letterSpacing: 0.5,
                  py: 2,
                }}
              >
                Email
              </TableCell>
              <TableCell
                sx={{
                  backgroundColor: '#e3f2fd',
                  fontWeight: 700,
                  borderBottom: 2,
                  borderColor: 'primary.main',
                  textTransform: 'uppercase',
                  letterSpacing: 0.5,
                  py: 2,
                }}
              >
                Cliente de Referencia
              </TableCell>
              <TableCell
                align="center"
                sx={{
                  backgroundColor: '#e3f2fd',
                  fontWeight: 700,
                  borderBottom: 2,
                  borderColor: 'primary.main',
                  textTransform: 'uppercase',
                  letterSpacing: 0.5,
                  py: 2,
                }}
              >
                Acciones
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {paginatedRows.length > 0 ? (
              paginatedRows.map((contacto, index) => (
                <TableRow
                  key={contacto.contactO_Id}
                  hover
                  sx={{
                    '&:hover': {
                      backgroundColor: '#f5f5f5',
                    },
                    backgroundColor: (theme) =>
                      index % 2 === 0 ? 'inherit' : theme.palette.action.hover,
                  }}
                >
                  <TableCell>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                      <PersonIcon
                        sx={{ color: 'primary.main', fontSize: 20 }}
                      />
                      <Typography sx={{ fontWeight: 500 }}>
                        {contacto.nombre || '—'}
                      </Typography>
                    </Box>
                  </TableCell>
                  <TableCell>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                      <BadgeIcon
                        sx={{ color: 'text.secondary', fontSize: 20 }}
                      />
                      <Typography>{contacto.apellido || '—'}</Typography>
                    </Box>
                  </TableCell>
                  <TableCell>
                    {contacto.ci ? (
                      <Chip
                        icon={<FingerprintIcon />}
                        label={contacto.ci}
                        size="small"
                        color="primary"
                        variant="outlined"
                      />
                    ) : (
                      <Typography color="text.secondary">—</Typography>
                    )}
                  </TableCell>
                  <TableCell>
                    {contacto.ruc ? (
                      <Chip
                        icon={<ReceiptIcon />}
                        label={contacto.ruc}
                        size="small"
                        color="secondary"
                        variant="outlined"
                      />
                    ) : (
                      <Typography color="text.secondary">—</Typography>
                    )}
                  </TableCell>
                  <TableCell>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                      <PhoneIcon
                        sx={{ color: 'text.secondary', fontSize: 20 }}
                      />
                      <Typography
                        sx={{ fontFamily: 'monospace', fontSize: '0.875rem' }}
                      >
                        {contacto.telefono || '—'}
                      </Typography>
                    </Box>
                  </TableCell>
                  <TableCell>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                      <EmailIcon
                        sx={{ color: 'text.secondary', fontSize: 20 }}
                      />
                      <Typography sx={{ fontSize: '0.875rem' }}>
                        {contacto.email || '—'}
                      </Typography>
                    </Box>
                  </TableCell>
                  <TableCell>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                      <AccountCircleIcon
                        sx={{ color: 'info.main', fontSize: 20 }}
                      />
                      <Typography>
                        {contacto.clientes
                          ? `${contacto.clientes.nombre} ${contacto.clientes.apellido}`
                          : '—'}
                      </Typography>
                    </Box>
                  </TableCell>
                  <TableCell align="center">
                    <Button
                      variant="contained"
                      size="small"
                      startIcon={<VisibilityIcon />}
                      onClick={() => abrirPerfilContacto(contacto)}
                      sx={{
                        textTransform: 'none',
                        fontWeight: 600,
                        borderRadius: 1.5,
                        px: 2,
                        boxShadow: 1,
                        '&:hover': {
                          boxShadow: 2,
                          transform: 'translateY(-1px)',
                        },
                        transition: 'all 0.2s ease',
                      }}
                    >
                      Perfil
                    </Button>
                  </TableCell>
                </TableRow>
              ))
            ) : (
              <TableRow>
                <TableCell colSpan={8} align="center" sx={{ py: 8 }}>
                  <ContactMailIcon
                    sx={{
                      fontSize: 64,
                      color: 'text.disabled',
                      opacity: 0.3,
                      mb: 2,
                    }}
                  />
                  <Typography variant="h6" color="text.secondary">
                    {termc
                      ? 'No se encontraron contactos con ese criterio'
                      : 'No hay contactos registrados'}
                  </Typography>
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        rowsPerPageOptions={[10, 25, 100]}
        component="div"
        count={filteredRows.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
        labelRowsPerPage="Filas por página:"
        labelDisplayedRows={({ from, to, count }) =>
          `${from}-${to} de ${count !== -1 ? count : `más de ${to}`}`
        }
        sx={{
          borderTop: 1,
          borderColor: 'divider',
          '.MuiTablePagination-selectLabel, .MuiTablePagination-displayedRows':
            {
              fontWeight: 500,
            },
        }}
      />
    </Box>
  );
}
